import React from 'react';
import Modal from 'react-modal';
import { MdClose } from 'react-icons/md';
import './style.scss';

interface ImageViewerCapacityModalProps {
  readonly isOpen: boolean;
  readonly message: string;
  readonly onClose: () => void;
}


const ImageViewerCapacityModal: React.FC<ImageViewerCapacityModalProps> = ({
  isOpen,
  message,
  onClose,
}) => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      bodyOpenClassName={null}
      portalClassName="react-modal-container"
      overlayClassName="react-modal-overlay image-viewer-capacity-modal-overlay"
      className="react-modal-wrapper"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <div
        className="react-modal image-viewer-capacity-modal"
        role="alertdialog"
        aria-labelledby="image-viewer-capacity-title"
        aria-describedby="image-viewer-capacity-message"
      >
        <div className="modal-header">
          <div className="modal-title-container">
            <div
              id="image-viewer-capacity-title"
              className="modal-title-in-container"
            >
              Image limit reached
            </div>
          </div>
          <div className="modal-header-buttons">
            <div
              className="modal-close"
              onClick={onClose}
              role="button"
              tabIndex={0}
              aria-label="Close"
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onClose();
                }
              }}
            >
              <MdClose />
            </div>
          </div>
        </div>

        <div className="modal-content">
          <p id="image-viewer-capacity-message">{message}</p>
        </div>

        <div className="modal-footer">
          <button type="button" className="xa-button primary" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ImageViewerCapacityModal;
